import _ from 'lodash';

export interface ILatLng {
  lat: number;
  lng: number;
}
export function geoDistanceInKm(point1: ILatLng, point2: ILatLng): number {
  const radiusOfEarth = 6371; // Radius of the earth in km
  const dLat = deg2rad(point2.lat - point1.lat);
  const dLng = deg2rad(point2.lng - point1.lng);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(point1.lat)) *
      Math.cos(deg2rad(point2.lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = radiusOfEarth * c; // Distance in km
  return _.round(d, 2);
}
const deg2rad = (deg: number) => deg * (Math.PI / 180);
